import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import PartnershipSelectValueContainer from '../PartnershipSelectValueContainer'

import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'

import useStyles from '../styles'

const PartnershipSelectorPreview = ({ additionalPartnershipInfo }) => {
  const classes = useStyles()

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const formattedSelectedPartnershipSelectProps = useMemo(
    () => ({
      value: {
        ...selectedPartnership,
        img: selectedPartnership.icon
      }
    }),
    [selectedPartnership]
  )

  return (
    <div className={classes.select}>
      <PartnershipSelectValueContainer
        selectProps={formattedSelectedPartnershipSelectProps}
        additionalPartnershipInfo={additionalPartnershipInfo}
        previewOnly
      />
    </div>
  )
}

PartnershipSelectorPreview.propTypes = {
  additionalPartnershipInfo: PropTypes.string
}

export default PartnershipSelectorPreview
